<template>
  <div class="goods-data">
    <div class="shop">
      <img class="shop-icon" :src="shopImg" />
      <span class="link">{{ $props.goods.sellerInfo.shopName }}</span>
      <div v-if="$props.goods.sellerInfo.shopName" class="entry-btn" @click="goShopDetail">
        {{ $t('product.goShop') }}
      </div>
    </div>
    <div class="g-name">
      {{ goods[titleKey] }}
    </div>
    <div class="action-tool">
      <!-- <el-icon
        v-if="$props.goods.detailUrl"
        class="copy"
        v-clipboard="$props.goods.detailUrl"
        v-clipboard:success="copySuccess"
        size="16"
        color="#31B38C"
      >
        <span class="iconfont icon-link"></span>
        <span class="originLink">{{ $t('product.originLink') }}</span>
      </el-icon> -->
      <div class="link-box" @click="copySuccess">
        <span class="iconfont icon-link"></span>
        <span class="originLink">{{ $t('product.originLink') }}</span>
      </div>
      <div class="reload-box" @click="refresh">
        <img class="refresh-icon" src="@/assets/images/product/refresh-icon.png" />
        <span>{{ $t('common.reload') }}</span>
      </div>
    </div>
    <p class="g-price">
      <template v-if="userStore.currency !== 'CNY'"
        ><span>CNY&nbsp;¥{{ activeCurrSku.writePrice }} </span>
        <span class="equal">≈</span>
      </template>
      <span
        >{{ userStore.currency }}&nbsp;{{ userStore.currencyUnit
        }}{{ $flatRateOrigin(activeCurrSku.writePrice, userStore.rate) }}
      </span>
      <!-- 促销价 -->
      <span
        class="old-price"
        v-if="activeCurrSku.promotionPrice && activeCurrSku.writePrice !== activeCurrSku.price"
        >￥ {{ activeCurrSku.price }}</span
      >
      <span v-if="$props.isComplete" class="edit-btn" @click="openEditPrice">
        <el-icon class="edit-icon">
          <Edit />
        </el-icon>
        {{ $t('common.edit') }}
      </span>
    </p>
  </div>
  <div class="float-goods-data">
    <img class="good-img" :src="$props.currentImg" />
    <div class="price-name">
      <p class="g-name">{{ goods[titleKey] }}</p>
      <p class="g-price">
        <template v-if="userStore.currency !== 'CNY'">
          <span>CNY&nbsp;¥{{ activeCurrSku.writePrice }} </span>
          <span class="equal">≈</span>
        </template>
        <span
          >{{ userStore.currency }}&nbsp;{{ userStore.currencyUnit
          }}{{ $flatRateOrigin(activeCurrSku.writePrice, userStore.rate) }}</span
        >
        <!-- 促销价 -->
        <span
          class="old-price"
          v-if="activeCurrSku.promotionPrice && activeCurrSku.writePrice !== activeCurrSku.price"
          >¥{{ activeCurrSku.price }}</span
        >
        <span v-if="$props.isComplete" class="edit-btn" @click="openEditPrice"
          ><el-icon class="edit-icon">
            <Edit /> </el-icon
          >{{ $t('common.edit') }}</span
        >
      </p>
    </div>
  </div>
  <EditPrice ref="editPriceRef" @edit-price="editPriceCallback" />
</template>

<script setup>
import { useUserStore } from '@/stores'
import { computed, defineEmits, defineProps, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import EditPrice from './EditPrice.vue'
const userStore = useUserStore()
const editPriceRef = ref()
const $emit = defineEmits(['update:goods', 'update:currSku', 'refreshData'])
const titleKey = computed(() => (userStore.language === 'cn' ? 'title' : 'titleEn'))
const $props = defineProps({
  goods: {
    type: Object,
    default: () => ({}),
  },
  currSku: {
    type: Object,
    default: () => ({}),
  },
  currentImg: {
    type: String,
    default: '',
  },
  isComplete: {
    type: Boolean,
    default: false,
  },
})

const activeGoods = computed({
  get() {
    return $props.goods
  },
  set(val) {
    $emit('update:goods', val)
  },
})
const activeCurrSku = computed({
  get() {
    return $props.currSku
  },
  set(val) {
    $emit('update:currSku', val)
  },
})
const shopImg = computed(() => {
  let img = ''
  switch ($props.goods.source) {
    case 'AL':
      img = require('@/assets/images/common/1688.png')
      break
    case 'WD':
      img = require('@/assets/images/common/weidian.png')
      break
    case 'TB':
      img = require('@/assets/images/common/taobao.png')
      break
    case 'GF':
      img = require('@/assets/images/common/xianyu.png')
      break
    default:
      break
  }
  return img
})

// 提供给后台的四项数据 (没登录)
const $router = useRouter()
const $route = useRoute()

// 前往店铺详情
const goShopDetail = () => {
  const query = {
    source: $route.query.source,
    sellerId: $props.goods.shopId,
    shopName: $props.goods.sellerInfo.shopName,
    // shopImg: shopImg.value
  }
  $router.push({ name: 'shop-detail', query })
}

// 复制
const copySuccess = () => {
  window.open($props.goods.detailUrl, '_blank')
  // ElMessage({ type: 'success', message: t('product.copySuccess') });
}
// 打开改价弹框
const openEditPrice = () => {
  editPriceRef.value.openModal()
}

// 改价回调
const editPriceCallback = ({ price, comment }) => {
  activeCurrSku.value.writePrice = price
  // activeCurrSku.value.promotionPrice = price;
  // console.log(activeCurrSku.value.writePrice)
  activeGoods.value.comment = comment
}

const refresh = () => {
  $emit('refreshData', true)
}
</script>

<style lang="scss" scoped>
.shop {
  padding-bottom: 12px;
  border-bottom: 1px solid var(--line-light-gray-color);
  margin-bottom: 21px;
  // display: flex;
  // align-items: center;
  overflow: hidden;

  .shop-icon {
    width: 24px;
    height: 24px;
    float: left;
  }

  .entry-btn {
    height: 30px;
    width: 97px;
    height: 24px;
    font-size: 12px;
    border-radius: 4px;
    text-align: center;
    color: var(--white-color-1);
    line-height: 24px;
    cursor: pointer;
    background-color: var(--border-black-1);
    float: right;
  }

  .link {
    float: left;
    color: var(--black-color-3d);
    font-family: Montserrat;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0em;
    font-variation-settings: 'opsz' auto;
    margin-left: 12px;
  }
}

.edit-btn {
  color: var(--primary-color);
  cursor: pointer;
  font-size: 14px;
  padding-left: 12px;
  display: flex;
  align-items: center;

  .edit-icon {
    font-size: 14px;
  }
}

.g-name {
  font-family: Montserrat;
  font-size: 18px;
  font-weight: bold;
  line-height: 27px;
  text-transform: capitalize;
  letter-spacing: 0em;
  font-variation-settings: 'opsz' auto;
  color: var(--black-color-3d);
  margin-bottom: 6px;
  display: flex;
  justify-content: space-between;
}

.action-tool {
  display: flex;
  align-items: center;

  // .copy {
  //   font-size: 12px;
  //   color: var(--primary-color);
  //   margin-left: 20px;
  //   transform: translateY(3px);
  //   cursor: pointer;
  // }
  .link-box {
    cursor: pointer;
    font-size: 12px;
    color: var(--primary-color);
    display: flex;
    align-items: center;

    .icon-link {
      color: var(--primary-color);
    }

    .originLink {
      font-size: 12px;
      color: var(--primary-color);
      margin-left: 4px;
    }
  }

  .reload-box {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
    color: var(--primary-color);

    .refresh-icon {
      width: 16px;
      height: 16px;
      margin-left: 8px;
      margin-right: 4px;
    }
  }
}

.g-price {
  font-family: Montserrat;
  font-size: 28px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: 'opsz' auto;
  color: var(--primary-color);
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  .equal {
    margin: 0 14px;
    color: var(--primary-color);
    font-size: 30px;
    font-weight: bold;
  }

  .old-price {
    color: $gray-color;
    font-size: 16px;
    text-decoration: line-through;
    margin-left: 16px;
  }
}

.float-goods-data {
  // position: absolute;
  // top: 20px;
  // left: 20px;
  display: none;
  // align-items: flex-end;
  justify-content: space-between;
  width: 398px;

  .good-img {
    width: 88px;
    height: 92px;
    border-radius: 8px;
    margin-right: 12px;
    display: block;
  }

  .price-name {
    margin-right: 20px;
    margin-top: 12px;
    width: 290px;

    .g-name {
      width: 290px;
      font-family: Montserrat;
      font-size: 14px;
      font-weight: bold;
      line-height: 21px;
      text-transform: capitalize;
      letter-spacing: 0em;
      font-variation-settings: 'opsz' auto;
      color: var(--black-color-3d);
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .g-price {
      margin-bottom: 0;
      font-size: 16px;
      color: var(--primary-color);
      display: flex;
      align-items: center;

      .equal {
        margin: 0 14px;
        color: var(--primary-color);
        font-size: 22px;
        font-weight: bold;
      }

      .old-price {
        font-size: 12px;
      }
    }
  }
}
</style>
